<div class="cookies-box" *ngIf="!IsCookieAccept">
    {{'accept-cookies:accept-cookies-text' | translate}}
    <span class="cookies-button" (click)="CloseTheCookies()">
        {{'accept-cookies:accept-cookies-button' | translate}}
    </span>
</div>